import React from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import assets from '../utils/assets';

export default function BookingCompletedPage() {
    const { type, id } = useParams();

    const { t } = useTranslation();

    return (
        <IonPage>
            <IonContent>
                <section id="success-page" className="relative pt-3 pb-32 font-sans text-center">
                    <p className="font-bold text-3xl">{t("bookingcompletedpage.p_1")}</p>
                    <img className="m-auto my-16" alt="Booking completed" src={assets.assetsPath("svg/booking_completed.svg")} />

                    <p className="font-semibold">{t("bookingcompletedpage.p_2")}</p>
                    <p className="font-thin">{t("bookingcompletedpage.p_3")}</p>

                    <div className="fixed bottom-0 w-full flex flex-col justify-center mt-8 px-4 py-6 bg-white">
                        <a href={`/${type}/q/${id}/`} className="block py-2 rounded-lg shadow-lg bg-mycia-red text-white">{t("bookingcompletedpage.a_1")}</a>
                    </div>
                </section>
            </IonContent>
        </IonPage>
    );
}
